import React, { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import { readString } from 'react-papaparse';
import Header from './header';
import Footer from './footer';
import dataCsv from '../../src/data/data.csv';
import './search.css';

const Search = () => {
  const { user } = useOutletContext();
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  
  const handleSubmit = (e) => {
    e.preventDefault();
    const searchTermValue = { searchTerm };
   
    const papaConfig = {
      complete: (results, file) => {
        const filteredData = results.data.filter((row) => {
          console.log(row);
          return row.some((item) => item.toLowerCase().includes(searchTermValue.searchTerm.toLowerCase()));
        });
       
        if (filteredData.length === 0) {
          console.log('No match found');
          setSearchResults([['Not found']]);
        } else {
          setSearchResults(filteredData);
        }
      },
      download: true,
      error: (error, file) => {
        console.log('Error while parsing:', error, file);
      },
    };
   
    readString(dataCsv, papaConfig);
    console.log('search results: ', searchResults);
  };

  return (
    <div className="App">
      <div className="flex-wrapper">
        <Header />
        <h1>Search for Banner Index</h1>
        <p>Welcome, {user || 'User'}!</p>
       
        <form onSubmit={handleSubmit}>
          <label>Index:</label>
          <input
            type="text"
            required
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <button>Search</button>
        </form>
       
        <br/>
        <img className='voyagerString' src={require('../Images/BannerIndexToVoyagerAccountString.png')} alt="Banner Index Guide" />
        <br/>
       
        <div className="Results">
          {searchResults.length > 0 && (
            <div className="table-container">
              <table className="results">
                <thead>
                  <tr>
                    <th>Banner Value</th>
                    <th>Voyager Value</th>
                    <th>Description</th>
                    <th>PTEOAF Value</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(searchResults).map((key, i) => {
                    return (
                      <tr key={i}>
                        {searchResults[key].map((dataItem, j) => {
                          let modifiedDataItem = dataItem;
                          if (!dataItem) {
                            modifiedDataItem = 'N/A';
                          }
                          return (
                            <td key={j}><span>{modifiedDataItem}</span></td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
          <br/><br/>
        </div>
       
        <Footer />
      </div>
    </div>
  );
};

export default Search;